import { Flex, Image, Text } from '@chakra-ui/react';
import React from 'react';

import undraw_quiz from '../../assets/images/undraw_quiz.svg';
function NotFound() {
  return (
    <Flex
      maxW={'100vw'}
      h='calc(100vh - 10rem)'
      alignItems='center'
      justifyContent='center'
      flexDirection='column'
      gap={10}
    >
      <Text as='h3'>Nothing was found here</Text>
      <Image
        width={['150px', '200px', '300px']}
        maxW='100%'
        src={undraw_quiz}
        alt='not found'
      />
    </Flex>
  );
}

export default NotFound;
